<template>
  <div class="views-notifications px-2 px-lg-4">
    <div class="container">
      <router-link
        :to="{ name: 'home' }"
        class="d-flex flex-column align-items-end py-2 pr-2"
      >
        <i class="icon-x"></i>
      </router-link>

      <h2 class="mb-4 font-weight-bold text-light">
        Notificações
      </h2>
      <h6 v-if="!data.itens.length" disabled>
        Nenhum item para exibir
      </h6>
      <template v-if="data.itens.length">
        <notification-item
          v-for="(notification, i) in sortedItems"
          :key="`notification-${i}`"
          :item="notification"
        />
      </template>
    </div>
  </div>
</template>

<script>
import NotificationItem from "@/components/notifications/NotificationItem.vue";
import { sortByDesc } from "@/functions/helpers";
export default {
  components: { NotificationItem },
  data() {
    return {
      data: {
        itens: [], //the correct is items, but api params is named itens
        not_visualized: 0,
        not_read: 0
      }
    };
  },
  mounted() {
    this.$store.dispatch("user/notifications").then(data => {
      this.data = { ...data };
    });
  },
  computed: {
    sortedItems() {
      return sortByDesc(this.data.itens, "created_at");
    },
    isDesktop() {
      return Window.innerWidth < "768px";
    }
  },
  method: {
    checkAll() {
      this.$store.dispatch("user/check_all_notifications").then(() => {
        this.$message.success("As notificações foram apagadas!");
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.views-notifications {
  .notification-wrapper {
    position: relative;

    i {
      font-size: 25px;
    }
    .notification-count {
      position: absolute;
      top: -20%;
      right: -10%;

      background: #2db563;
      border-radius: 50%;
      font-size: 12px;
      height: 17px;
      width: 17px;

      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  ::v-deep .dropdown-toggle:before {
    content: none;
  }

  ::v-deep .dropdown-menu {
    background: #111112;
    width: 460px;
    @media screen and (max-width: 768px) {
      width: 100vw;
    }
  }

  .scroll-content {
    scroll-behavior: smooth;
    overflow-y: scroll;
    max-height: 400px;

    @media screen and (max-width: 768px) {
      max-height: 300px;
    }

    &::-webkit-scrollbar {
      background: #2c2c2c;
      border-radius: 50%;
      width: 8px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: #0a0a0a;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #888;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
  .icon-x {
    color: #2db563;
    font-size: 20px;
  }
}
</style>
